var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRetryVector = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 10 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.393 6.572H.715V9.25",
  stroke: "#5A687B",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.87 7.095a3.98 3.98 0 0 1-7.672-.523M6.607 4.429h2.679V1.75",
  stroke: "#5A687B",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.13 3.905a3.98 3.98 0 0 1 7.672.524",
  stroke: "#5A687B",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgRetryVector as ReactComponent };
export default __webpack_public_path__ + "assets/media/retry-vector.d311390ee7da5949d8458790b6ca5bd9.svg";